import { memo } from 'react'
import { Card } from '@/components/ui/Card'
import { Users, CheckCircle, Clock, TrendingUp } from 'lucide-react'
import type { JiraPeopleOverviewData } from '@/types/jira'

interface JiraOverviewStatsProps {
  data: JiraPeopleOverviewData
}

const JiraOverviewStats = memo(function JiraOverviewStats({ data }: JiraOverviewStatsProps) {
  const { people, totalOpenTasks, totalCompletedTasks } = data

  const stats = [
    {
      label: 'Team Members',
      value: people.length,
      icon: Users,
      color: 'blue',
      bgColor: 'bg-blue-100 dark:bg-blue-900/30',
      iconColor: 'text-blue-600 dark:text-blue-400',
    },
    {
      label: 'Open Tasks',
      value: totalOpenTasks,
      icon: Clock,
      color: 'amber',
      bgColor: 'bg-amber-100 dark:bg-amber-900/30',
      iconColor: 'text-amber-600 dark:text-amber-400',
    },
    {
      label: 'Completed (30d)',
      value: totalCompletedTasks,
      icon: CheckCircle,
      color: 'green',
      bgColor: 'bg-green-100 dark:bg-green-900/30',
      iconColor: 'text-green-600 dark:text-green-400',
    },
    {
      label: 'Completion Rate',
      value: `${totalOpenTasks + totalCompletedTasks > 0 
        ? Math.round((totalCompletedTasks / (totalOpenTasks + totalCompletedTasks)) * 100) 
        : 0}%`,
      icon: TrendingUp,
      color: 'purple',
      bgColor: 'bg-purple-100 dark:bg-purple-900/30',
      iconColor: 'text-purple-600 dark:text-purple-400',
    },
  ]

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat) => {
        const Icon = stat.icon
        return (
          <Card key={stat.label} variant="compact" padding="sm">
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-lg ${stat.bgColor}`}>
                <Icon className={`h-5 w-5 ${stat.iconColor}`} />
              </div>
              <div>
                <p className="text-xs text-gray-500 dark:text-gray-400">{stat.label}</p>
                <p className="text-lg font-bold text-gray-900 dark:text-white">{stat.value}</p>
              </div>
            </div>
          </Card>
        )
      })}
    </div>
  )
})

export default JiraOverviewStats

